import {Injectable} from '@angular/core';
import {ApiServiceService} from '../api-service.service';
import {HttpClient} from '@angular/common/http';
import {LoanSubventionDetails, Subvention} from '../model/subvention-preference.model';

@Injectable()
export class SubventionService {
    private apiService: ApiServiceService;
    private http: HttpClient;

    constructor(apiService: ApiServiceService, http: HttpClient) {
        this.apiService = apiService;
        this.http = http;
    }

    async getSubvention(loanId: string): Promise<Subvention> {
        const url = `${this.apiService.baseURL()}subvention?loanId=${loanId}`;
        return await this.http.get<Subvention>(url).toPromise();
    }

    async getSubventionsForLoans(loanIds: string[]): Promise<Subvention[]> {
        const url = `${this.apiService.baseURL()}subvention/for-loans`;
        return this.http.post<Subvention[]>(url, loanIds).toPromise();
    }

    async getSubventionDetailsForLoans(loanIds: string[]): Promise<LoanSubventionDetails[]> {
        const url = `${this.apiService.baseURL()}loans/subvention-details`;
        return this.http.post<LoanSubventionDetails[]>(url, loanIds).toPromise();
    }
}
